/**
 * Payment related reducer functions
 */

import { orderCompleted } from '../analytics'
import { cartEmpty } from '../initialState'

/**
 * Handle payment completion
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} order - Completed order
 */
export const paymentComplete = (global, dispatch, order) => {
  // Always clear cart on payment complete
  if (order) {
    orderCompleted(order)
  }

  return {
    ss: {},
    pd: {},
    ts: {
      pc: false,
    },
    ...cartEmpty,
    // Preserve cartOpen state to prevent unwanted closing during payment
    cartOpen: false
  }
}
